var site = site || {};
var Mustache = Mustache || {};

(function($) {
  site.cartConfirm = function () {
    var that = {
      content: null,
      kitContent: null,
      cartItems: null,
      transData: null,
      enablePgRestApiAtb: false,
      init : function() {
        this.content = $('script.inline-template[path="cart_confirm"]').html();
        this.kitContent = $('script.inline-template[path="cart_kit_confirm"]').html();
        if (typeof this.content === 'undefined' || !this.content) { return null; }
        that.enablePgRestApiAtb = Drupal?.settings?.pg_rest_api?.cart?.enabled;
        $(document).on('addToCart.success', function (e, responseData) {
          if (that.enablePgRestApiAtb) {
            that.handleRestApiSuccess(responseData);
          } else {
            that.handleJsonRpcSuccess(responseData);
          }
        });
        var _normalizeResponseKeys = function (items, recursionLevel) {
          recursionLevel = recursionLevel || 0;
          if (Object.prototype.toString.call(items) !== '[object Array]' || recursionLevel > 1) {
            return items;
          }
          var replaceKey = function(key) {
            return key.replace(/\./, '_');
          };
          var out = [];
          for (var i = 0, len = items.length; i < len; i++) {
            out[i] = {};
            for (var key in items[i]) {
              if (items[i].hasOwnProperty(key)) {
                out[i][replaceKey(key)] = items[i][key];
              }
              if (key === 'items' && items[i][key] && items[i][key].length) {
                out[i][replaceKey(key)] = _normalizeResponseKeys(items[i][key], recursionLevel + 1);
              }
            }
          }
          return out;
        };
        $(document).on('addKitToCart.success', function (e, cartResult) {
          var collectionId = cartResult.coll_info.COLLECTION_ID;
          var kitItem = {
            itemInfo: {},
          };
          var kit = cartResult.trans_data.order.kits;
          var addedItem = _.filter(kit, function(item) {
            if (item['COLLECTION_ID'] === collectionId) {
              return item;
            }
          });
          kitItem.itemInfo = _normalizeResponseKeys(addedItem);
          var itemCount = cartResult.trans_data.items_count;
          $('.js-page-utilities__cart-count').html(itemCount);
          that.launch(kitItem);
        });
        $(document).on('addToCart.failure', function (e, cartMessage) {
          var overlayContent = '';

          cartMessage.forEach(function (cartMessage){
            overlayContent = overlayContent.concat(cartMessage.text + '<br>');
          });
          generic.overlay.launch({
            content: overlayContent,
            includeBackground: true,
            cssStyle:{
              width:"540px",
              height:"200px",
            }
          });
        });
      },
      handleRestApiSuccess: function (responseData) {
        var wrappedResponse = generic.checkout.cart.wrapAjaxResponse(responseData);
        var cartResult = wrappedResponse.getCartResults();

        that.cartItems = wrappedResponse.getOrderItems().map(normalizeItem);

        var lastAddedCartItem = that.cartItems[0];
        var lastAddedItemSku = lastAddedCartItem?.product?.sku;
        var skuBaseID = lastAddedItemSku['SKU_BASE_ID'];

        that.transData = cartResult?.trans;
        
        $('.js-page-utilities__cart-count').html(cartResult.trans_items_count);

        if (skuBaseID !== null) {
          let allItems = that.cartItems;
          let preOrderCartItems;
          if (typeof that.transData !== 'undefined') {
            preOrderCartItems = typeof that.transData.preorder !== 'undefined' ? that.transData.preorder.items : '';
            allItems = allItems.concat(preOrderCartItems);
          }
          allItems.some(function (item) {
            if (item && item?.product?.sku['SKU_BASE_ID'] === skuBaseID) {
              lastAddedCartItem.preOrderMsgShort = item.preOrderMsgShort;
              return true;
            }
            return false;
          });

          that.launch(lastAddedCartItem);
        }
      },
      handleJsonRpcSuccess: function (responseData) {

        if (!responseData || typeof responseData.getItem !== 'function') {
          return null;
        }

        var item_count = responseData.getCount();
        var sku = responseData.getItem().product.sku;
        var shadeHex = sku.HEX_VALUE_STRING;
        var skuBaseID = sku.SKU_BASE_ID;
        $('.js-page-utilities__cart-count').html(item_count);

        // Don't show cart overlay if flag is set.
        if (typeof responseData.updateCountOnly !== 'undefined') {
          return null;
        }

        if (shadeHex != null) {
          shadeHex = shadeHex.split(',');
          if (shadeHex.length === 1) {
            sku['SWATCH_TYPE'] = 'single';
            sku['HEX_VALUE_1'] = shadeHex[0];
          } else if (shadeHex.length === 2) {
            sku['SWATCH_TYPE'] = 'duo';
            sku['HEX_VALUE_1'] = shadeHex[0];
            sku['HEX_VALUE_2'] = shadeHex[1];
          } else if (shadeHex.length === 3) {
            sku['SWATCH_TYPE'] = 'trio';
            sku['HEX_VALUE_1'] = shadeHex[0];
            sku['HEX_VALUE_2'] = shadeHex[1];
            sku['HEX_VALUE_3'] = shadeHex[2];
          } else if (shadeHex.length === 5) {
            sku['SWATCH_TYPE'] = 'quint';
            sku['HEX_VALUE_1'] = shadeHex[0];
            sku['HEX_VALUE_2'] = shadeHex[1];
            sku['HEX_VALUE_3'] = shadeHex[2];
            sku['HEX_VALUE_4'] = shadeHex[3];
            sku['HEX_VALUE_5'] = shadeHex[4];
          }
        }

        if (skuBaseID !== null) {
          let allItems = responseData.getAllItems();
          let preOrderCartItems;
          if (typeof responseData.getTransData !== 'undefined') {
            preOrderCartItems = typeof responseData.getTransData().preorder !== 'undefined'
              ? responseData.getTransData().preorder.items
              : '';
            allItems = allItems.concat(preOrderCartItems);
          }
          $.each(allItems, function(i, item) {
            if (item && item['sku.SKU_BASE_ID'] === skuBaseID) {
              responseData.getItem().preOrderMsgShort = item.preOrderMsgShort;
              return false;
            }
          });
          that.launch(responseData.getItem());
        }
      },
      launch : function (cartItem) {
        var html = '';
        var skuPrice = '';

        if (that.enablePgRestApiAtb) {
          skuPrice = cartItem['sku.PRICE'];
        } else {
          skuPrice = cartItem?.product?.sku?.PRICE;
        }

        if (cartItem.hasOwnProperty('itemInfo')) {
          html = Mustache.render(this.kitContent, cartItem);
        } else {
          html = Mustache.render(this.content, cartItem);

          if (parseInt(skuPrice, 10) === 0) {
            $('.js-cart-confirm-engrave-price').html(cartItem['sku.formattedPrice']);
          }
        }
        
        if (html !== '') {
          $('.js-cart-confirm__content').html(html).parent().fadeIn('200');
        }
        /**
         * Override engraving price defined in the CMS.
         * For priced skus, it is $10 defined in the CMS
         * For promotional skus, it is $0.
         */
        $(document).trigger('productQV:rendered:LoyaltyPrices', $('.js-cart-confirm__content'));
        $(document).trigger('cart_confirm_fade_in');
        setTimeout(function() {
          $('.js-cart-confirm__content').parent().fadeOut('200');
          $(document).trigger('cart_confirm_fade_out');
        }, 3500);
        if (site && site.track) {
          site.track.cartOverlay();
        }
      }
    };

    // Normalize cartItems data to match old JSONRPC structure.
    function normalizeItem (item) {
      const prodData = {};
      const skuData = {};

      for (let key in item) {
        if (item.hasOwnProperty(key) && key.startsWith('prod.')) {
          prodData[key.substring(5)] = item[key];
          delete item[key];
        }
        if (item.hasOwnProperty(key) && key.startsWith('sku.')) {
          skuData[key.substring(4)] = item[key];
          delete item[key];
        }
      }

      item.product = prodData;
      item.product.sku = skuData;
      skuData.XXS_IMAGE = skuData.THUMBNAIL_IMAGE
        ? skuData.THUMBNAIL_IMAGE
        : skuData.SMALL_IMAGE;

      // Multi-Shade Products.
      const swatchList = skuData.swatchList;
      const swatchTypes = {
        1: 'single',
        2: 'duo',
        3: 'trio',
        5: 'quint'
      };

      if (Array.isArray(swatchList) && swatchList.length) {
        const type = swatchTypes[swatchList.length];

        if (type) {
          skuData.SWATCH_TYPE = type;
          swatchList.forEach((hex, index) => {
            skuData[`HEX_VALUE_${index + 1}`] = hex;
          });
        }
      }

      return item;
    }

    return that;
  }();
})(jQuery);

(function($) {
  site.wishlistConfirm = function () {
    var that = {
      content : null,
      init : function() {
        this.content = $('script.inline-template[path="wishlist_confirm"]').html();
        if (typeof this.content == 'undefined' || !this.content) { return null; }
        $(document).on('addToWishlist.success', function(e, cartResult) {
          that.launch({wishlist_add_success: true});
        });
        $(document).on('addToWishlist.exists', function(e, result) {
          that.launch({wishlist_add_exists: true});
        });
      },
      launch : function(args) {
        var html = Mustache.render(this.content, args);
        $.colorbox({
          html: html,
          className: 'colorbox__wishlist-confirm',
          width: "350px",
          height: "190px",
        });
        $(".js-wishlist-confirm-close").one( "click", function(){
          $.colorbox.close();
        });
      }
    };
    return that;
  }();
})(jQuery);

(function($) {
  site.offerConfirm = function () {
    var that = {
      content : null,
      init : function() {
        this.content = $('script.inline-template[path="offer_confirm"]').html();
        if (typeof this.content == 'undefined' || !this.content) { return null; }
        $(document).on('addOffer.success', function(e, offerResult) {
          that.launch(offerResult);
        });
      },
      launch : function(args) {
        var html = Mustache.render(this.content, args);
        $('.js-cart-confirm__content').html(html).parent().fadeIn('200');
        setTimeout(function() {
          $('.js-cart-confirm__content').parent().fadeOut('200');
        }, 3500);
      }
    };
    return that;
  }();
})(jQuery);

